
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export const  errorToastMessage=(errMsgVal)=> {
    console.log("totast mesage")
    toast.error(`${errMsgVal}`, {
      position: "bottom-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }


  export const successToastMessage=(errMsgVal)=> {
     toast.success(`${errMsgVal}`, {
      position: "bottom-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }